import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'ImageList',
})(({ brandColors, spacing, breakpoints, typography }, props) => ({
  ImageListItem: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  image: {
    objectFit: 'cover',
    objectPosition: 'center center',
    flexShrink: 0,
    borderRadius: typography.pxToRem(8),
  },
  itemBody: {
    marginLeft: 0,
    marginTop: spacing(1),
    [breakpoints.up('md')]: {
      marginLeft: spacing(1),
      marginTop: 0,
    },
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    color: darkOrLightStyle(props)(brandColors.white, brandColors.primaryMain),
    [breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  body: {
    marginTop: spacing(0),
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  chip: {
    display: 'flex',
    padding: `${typography.pxToRem(4)}  ${typography.pxToRem(8)}`,
    alignItems: 'center',
    borderRadius: typography.pxToRem(32),
    margin: `${spacing(-1)} 0 0 0`,
    width: typography.pxToRem(98),
    color: darkOrLightStyle(props)(
      brandColors.primaryMain,
      brandColors.heroYellow10
    ),
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsChargeBlue60,
      brandColors.heroYellow
    ),
    [breakpoints.up('sm')]: {
      margin: `0 0 0 ${spacing(0)}`,
    },
  },
}));

export default useStyles;
